"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CXTupleToI18nDomainArgs = void 0;
const config_type_1 = require("../config-type");
const i18n_args_1 = require("./i18n-args");
/**
 * Input args to be used to query CXTuple to I18nDomain mappings.
 */
class CXTupleToI18nDomainArgs extends i18n_args_1.I18nArgs {
    constructor(_cxFamily, _cxId, _cxProgram) {
        super();
        this._cxFamily = _cxFamily;
        this._cxId = _cxId;
        this._cxProgram = _cxProgram;
    }
    get cxFamily() {
        return this._cxFamily;
    }
    get cxId() {
        return this._cxId;
    }
    get cxProgram() {
        return this._cxProgram;
    }
    getConfigType() {
        return config_type_1.ConfigType.CX_TUPLE_TO_I18N_DOMAIN;
    }
    getArgsMap() {
        return new Map([
            ['cx_family', this._cxFamily],
            ['cx_id', this._cxId],
            ['cx_program', this._cxProgram]
        ]);
    }
}
exports.CXTupleToI18nDomainArgs = CXTupleToI18nDomainArgs;
/**
 * Builder class that build the {@link CXTupleToI18nDomainArgs} instance.
 */
CXTupleToI18nDomainArgs.Builder = (_a = class {
        constructor() {
            this.cxProgram = CXTupleToI18nDomainArgs.Builder.EMPTY_CX_PROGRAM;
        }
        /**
         * Sets the CXFamily within the {@link CXTupleToI18nDomainArgs}
         * container.
         *
         * @param cxFamily CXFamily to be used for the config query.
         *
         * @return builder instance
         */
        withCxFamily(cxFamily) {
            this.cxFamily = cxFamily;
            return this;
        }
        /**
         * Sets the CXId within the {@link CXTupleToI18nDomainArgs}
         * container.
         *
         * @param cxId CXId to be used for the config query.
         *
         * @return builder instance
         */
        withCxId(cxId) {
            this.cxId = cxId;
            return this;
        }
        /**
         * Sets the cxProgram within the {@link CXTupleToI18nDomainArgs}
         * container.
         *
         * @param cxProgram cxProgram to be used for the config query.
         *
         * @return builder instance
         */
        withCxProgram(cxProgram) {
            this.cxProgram = cxProgram;
            return this;
        }
        /**
         * Builds the {@link CXTupleToI18nDomainArgs} class using the previously set
         * properties.
         *
         * @return {@link CXTupleToI18nDomainArgs} class instance
         */
        build() {
            return new CXTupleToI18nDomainArgs(this.cxFamily, this.cxId, this.cxProgram);
        }
    },
    _a.EMPTY_CX_PROGRAM = '[]',
    _a);
//# sourceMappingURL=cx-tuple-to-i18n-domain-args.js.map